document.addEventListener('DOMContentLoaded', function() {
  // Simple direct approach for menu transitions
  
  // Add transition classes to all submenus
  document.querySelectorAll('.header__submenu').forEach(submenu => {
    submenu.classList.add('submenu-transition');
  });
  
  // Top-level menu accordion behavior
  const topLevelSummaries = document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details > summary');
  topLevelSummaries.forEach(summary => {
    summary.addEventListener('click', function(e) {
      // Don't handle link clicks
      if (e.target.tagName === 'A' || e.target.closest('a')) return;
      
      const currentDetails = this.parentNode;
      
      // If this menu is already open, let the browser handle closing it
      if (currentDetails.hasAttribute('open')) return;
      
      // Close all other top-level menus
      topLevelSummaries.forEach(otherSummary => {
        const otherDetails = otherSummary.parentNode;
        if (otherDetails !== currentDetails && otherDetails.hasAttribute('open')) {
          // Close it
          otherDetails.removeAttribute('open');
          
          // Apply closing animation
          const submenu = otherDetails.querySelector('.header__submenu');
          if (submenu) {
            submenu.classList.add('is-closing');
            submenu.classList.remove('is-opening');
            setTimeout(() => submenu.classList.remove('is-closing'), 150);
          }
        }
      });
    });
  });
  
  // Sub-menu accordion behavior
  document.querySelectorAll('.header__submenu li > details > summary').forEach(summary => {
    summary.addEventListener('click', function(e) {
      // Don't handle link clicks
      if (e.target.tagName === 'A' || e.target.closest('a')) return;
      
      // Stop event from bubbling to parent menus
      e.stopPropagation();
      
      const currentDetails = this.parentNode;
      
      // If this submenu is already open, let the browser handle closing it
      if (currentDetails.hasAttribute('open')) return;
      
      // Find parent list item
      const parentLi = currentDetails.closest('li');
      if (!parentLi) return;
      
      // Find parent submenu
      const parentSubmenu = parentLi.closest('.header__submenu');
      if (!parentSubmenu) return;
      
      // Close all other submenus at the same level
      parentSubmenu.querySelectorAll('li > details').forEach(otherDetails => {
        if (otherDetails !== currentDetails && otherDetails.hasAttribute('open')) {
          // Close it
          otherDetails.removeAttribute('open');
          
          // Apply closing animation
          const submenu = otherDetails.querySelector('.header__submenu');
          if (submenu) {
            submenu.classList.add('is-closing-nested');
            submenu.classList.remove('is-opening-nested');
            setTimeout(() => submenu.classList.remove('is-closing-nested'), 150);
          }
        }
      });
    });
  });
  
  // Animation for opening/closing menus
  document.querySelectorAll('details').forEach(details => {
    let isAnimating = false;
    
    details.addEventListener('toggle', function() {
      if (isAnimating) return;
      isAnimating = true;
      
      const submenu = this.querySelector('.header__submenu');
      if (!submenu) {
        isAnimating = false;
        return;
      }
      
      // Check if this is a nested submenu
      const isNested = submenu.closest('.header__submenu li > details > .header__submenu') !== null;
      
      if (this.open) {
        // Opening animation
        if (isNested) {
          submenu.classList.add('is-opening-nested');
          submenu.classList.remove('is-closing-nested');
          setTimeout(() => {
            submenu.classList.remove('is-opening-nested');
            isAnimating = false;
          }, 200);
        } else {
          submenu.classList.add('is-opening');
          submenu.classList.remove('is-closing');
          setTimeout(() => {
            submenu.classList.remove('is-opening');
            isAnimating = false;
          }, 200);
        }
      } else {
        // Closing animation
        if (isNested) {
          submenu.classList.add('is-closing-nested');
          submenu.classList.remove('is-opening-nested');
          setTimeout(() => {
            submenu.classList.remove('is-closing-nested');
            isAnimating = false;
          }, 150);
        } else {
          submenu.classList.add('is-closing');
          submenu.classList.remove('is-opening');
          setTimeout(() => {
            submenu.classList.remove('is-closing');
            isAnimating = false;
          }, 150);
        }
      }
    });
  });
  
  // Prevent clicks on links from toggling dropdowns
  document.querySelectorAll('.header__submenu a').forEach(link => {
    link.addEventListener('click', e => e.stopPropagation());
  });
});
